import { tuApptoAPI, getAuthHeaders, getErrorData } from './config'

const withConfig = (config = {}, auth = false) =>
  auth ? { ...config, ...getAuthHeaders(config.headers || {}) } : config

const request = async (method, url, data = null, options = {}) => {
  const { auth = false, config = {}, fallbackMessage, rawResponse = false } = options

  try {
    const response = await tuApptoAPI({
      method,
      url,
      data,
      ...withConfig(config, auth),
    })
    return rawResponse ? response : response.data
  } catch (error) {
    return getErrorData(error, fallbackMessage)
  }
}

export const apiGet = (url, options = {}) => request('get', url, null, options)

export const apiPost = (url, data = {}, options = {}) => request('post', url, data, options)

export const apiPut = (url, data = {}, options = {}) => request('put', url, data, options)

export const apiDelete = (url, options = {}) => request('delete', url, null, options)
